module.exports = __webpack_public_path__ + "static/media/right-arrow.6d38aa5a.svg";